import axios, { AxiosError, AxiosHeaders, AxiosStatic } from 'axios';

import ApiCache from './apiCache';

const formatError = (error: AxiosError) => ({
  code: error.response?.status,
  message: error.message,
  data: error.response?.data,
});

const apiCache = new ApiCache();
const axiosInstances: { [key: string]: AxiosStatic } = {};

export const getAxiosInstance = (base_url: string, token?: string) => {
  const axiosInstance = axios;
  axiosInstance.defaults.baseURL = base_url;
  axiosInstance.interceptors.request.use((config) => {
    apiCache.handleRequest(config);
    if (token && config.headers) (config.headers as AxiosHeaders).set('Authorization', `Bearer ${token}`);
    return config;
  });

  axiosInstance.interceptors.response.use(
    (response) => apiCache.handleResponse(response),
    (error: AxiosError) => {
      return Promise.reject(error.response ? formatError({ ...error }) : error);
    }
  );
  return axiosInstance;
};

export const dynamicAxios = (base_url: string, token?: string) => {
  const key = `${base_url}_${token || ''}`;
  const existingAxiosInstance = axiosInstances[key];
  if (!existingAxiosInstance) {
    const newAxiosInstance = getAxiosInstance(base_url, token);
    axiosInstances[key] = newAxiosInstance;
    return newAxiosInstance;
  }
  return existingAxiosInstance;
};

export default dynamicAxios;
export type AxiosInstanceType = AxiosStatic;
